import { IAddUpdateBannerRequest } from "../../../../model/admin-portal/request/add-update-banner-request";
import { IAddUpdateCategoryNewsRequest } from "../../../../model/admin-portal/request/add-update-category-news-request";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { IBannersListResponse } from "../../../../model/admin-portal/response/banners-list-response";
import { ICategoriesNewsListResponse } from "../../../../model/admin-portal/response/categories-news-list-response";
import { ILinkServicesListResponse } from "../../../../model/admin-portal/response/link-services-list-response";
import { INewsListRespomse } from "../../../../model/admin-portal/response/news-list-response";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";


export type CadastrosBasicoState = {
    dataPaginatedListResponse: PaginationResponse<IBannersListResponse | ICategoriesNewsListResponse | ILinkServicesListResponse | INewsListRespomse>;
    isLoadingData: boolean;
    dataSearchRequest: ITermPaggedRequest;
    dataResponse: IBannersListResponse | ICategoriesNewsListResponse | ILinkServicesListResponse | INewsListRespomse;
    dataRequest: any;
    showAddEdit: boolean;
    file: File | null;
    categoriesNews: ICategoriesNewsListResponse[];
};
export enum FORM_TYPES {
    banners = 'banners',
    categoriesNews = 'categoriesNews',
    linkServices = 'linkServices',
    news = 'news',

    estruturaGovernametal = 'estruturaGovernametal',

}
export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setDataResponse = 'setDataResponse',
    setDataSearchRequest = 'setDataSearchRequest',
    setDataRequest = 'setDataRequest',
    setIsLoadingData = 'setIsLoadingData',
    setShowAddEdit = 'setShowAddEdit',
    setFile = 'setFile',
    setCategoriesNews = 'setCategoriesNews'

}

export const CadastrosBasicoReducer = (state: CadastrosBasicoState, action: any): CadastrosBasicoState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return {
                ...state,
                dataPaginatedListResponse: payload,
            };
        case ACTION_TYPES.setDataRequest:
            return {
                ...state,
                dataRequest: payload,
            };
        case ACTION_TYPES.setDataResponse:
            return {
                ...state,
                dataResponse: payload,
            };
        case ACTION_TYPES.setShowAddEdit:
            return {
                ...state,
                showAddEdit: payload,
            };
        case ACTION_TYPES.setDataSearchRequest:
            return {
                ...state,
                dataSearchRequest: payload,
            };
        case ACTION_TYPES.setIsLoadingData:
            return {
                ...state,
                isLoadingData: payload,
            };
        case ACTION_TYPES.setCategoriesNews:
            return {
                ...state,
                categoriesNews: payload,
            };
        case ACTION_TYPES.setFile:
            return {
                ...state,
                file: payload,
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}